var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticClass:"badge-range md f-400",attrs:{"variant":_vm.status.variant,"title":_vm.tr(_vm.status.title)}},[_c('i',{staticClass:"fas mr-1",class:_vm.status.glyph}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }